import { MemberResponse } from '../shared/types'
import { DropDownElement } from '../shared/components/DropDownComponent'

const getEventMemberDropdownOptions = (eventMember: MemberResponse) => {
  const options: DropDownElement[] = []
  eventMember.results.map(member => {
    member.originId && options.push({
      key: member.originId,
      value: `${member.firstname} ${member.lastname}`,
    })
  })
  options.sort((a, b) => {
    const nameA = a.value.toUpperCase()
    const nameB = b.value.toUpperCase()
    if (nameA < nameB) {
      return -1
    }
    if (nameA > nameB) {
      return 1
    }

    // names must be equal
    return 0
  })
  return options
}

export default getEventMemberDropdownOptions
